import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import Applayout from "./layout/applayout";
import Swal from "sweetalert2";
import { useParams, Link } from "react-router-dom";
import axiosClient from "../axios/axiosClient";
import { toast } from "react-toastify";
import Modal from "../components/app/modal";
import "./fileUploader.css";
import AuthContext from "../context/AuthContext";

function Viewcase() {
  const [modalTitle, setModalTitle] = useState("View Document");
  const [loading, setLoading] = useState(false);
  const [documentId, setDocumentId] = useState("");
  const [cases, setCases] = useState([]);
  const [file, setFile] = useState(null);
  const [currentDoc, setCurrentDoc] = useState([]);
  const fileInputRef = useRef(null);
  const { id } = useParams();

  const [formData, setFormData] = useState({
    requirement: "",
    beneficiary_case_id: id,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileSelect = (event) => {
    setFile(event.target.files[0]);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    if (event.dataTransfer.files && event.dataTransfer.files[0]) {
      const file = event.dataTransfer.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          // Set the base64 string as part of the form data
          setFile(event.dataTransfer.files[0], reader.result);
        };
        reader.readAsDataURL(file); // Convert to Base64
      }
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const showInterest = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Show Interest!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axiosClient
          .get(`/beneficiary-cases/${id}/interest`)
          .then((response) => {
            getCases();
            Swal.fire(
              "Successful!",
              "You are now the case manager.",
              "success"
            );
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            toast.error(error.response.data.message);
          });
      } else {
        Swal.fire("Cancel!", "You cancelled your interest.", "error");
      }
    });
  };

  const approveCase = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Approve!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axiosClient
          .get(`/beneficiary-cases/${id}/approve`)
          .then((response) => {
            getCases();
            Swal.fire(
              "Successful!",
              "This case has been approved.",
              "success"
            );
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            toast.error(error.response.data.message);
          });
      } else {
        Swal.fire("Cancel!", "You cancelled approval.", "error");
      }
    });
  };
  const inReview = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Approve!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axiosClient
          .get(`/beneficiary-cases/${id}/in-review`)
          .then((response) => {
            getCases();
            Swal.fire(
              "Successful!",
              "This case is now in review.",
              "success"
            );
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            toast.error(error.response.data.message);
          });
      } else {
        Swal.fire("Cancel!", "You cancelled approval.", "error");
      }
    });
  };

  const declineCase = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Decine!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axiosClient
          .get(`/beneficiary-cases/${id}/decline`)
          .then((response) => {
            getCases();
            Swal.fire(
              "Successful!",
              "This case has been declined.",
              "success"
            );
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            toast.error(error.response.data.message);
          });
      } else {
        Swal.fire("Cancel!", "You cancelled operation.", "error");
      }
    });
  };

  const enableReupload = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Enable!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axiosClient
          .post(`/case-documents/${documentId}/re-upload`)
          .then((response) => {
            Swal.fire("Successful!", "You can re-upload your file.", "success");
            getCases();
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            toast.error(error.response.data.message);
          });
      } else {
        Swal.fire("Cancel!", "You cancelled your interest.", "error");
      }
    });
  };

  const uploadRequirement = () => {
    const data = {
      ...formData,
      requirement: null,
    };
    setLoading(true);

    const reader = new FileReader();
    reader.onloadend = () => {
      data.requirement = reader.result;

      axiosClient
        .post(`/case-documents/${documentId}/upload-requirement`, data)
        .then((response) => {
          getCases();
          toast.success(response.data.message);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.response.data.message);
        });
    };
    reader.readAsDataURL(file);
  };
  const uploadProof = () => {
    const data = {
      ...formData,
      requirement: null,
    };
    setLoading(true);

    const reader = new FileReader();
    reader.onloadend = () => {
      data.proof = reader.result;

      axiosClient
        .post(`/beneficiary-cases/${id}/upload-proof`, data)
        .then((response) => {
          getCases();
          toast.success(response.data.message);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.response.data.message);
        });
    };
    reader.readAsDataURL(file);
  };

  const getCases = useCallback(() => {
    axiosClient
      .get(`/beneficiary-cases/${id}`)
      .then((response) => {
        setCases(response.data.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Login failed. Please check your credentials.");
      });
  }, [id]);

  const handleDocRequest = () => {
    axiosClient
      .post(`/case-documents/request`, formData)
      .then((response) => {
        getCases();
        setLoading(false);
        toast.success(response.data.message);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response.data.message);
      });
  };

  const removeProof = () => {
    setLoading(true);
    axiosClient
      .delete(`/beneficiary-cases/${id}/remove-proof`)
      .then((response) => {
        toast.success(response.data.message);
        getCases();
        setLoading(false);
        // Close the modal
        document.querySelector('[data-bs-dismiss="modal"]').click();
      })
      .catch((error) => {
        toast.error(error.response.data.message);
        setLoading(false);
      });
  };

  const { user } = useContext(AuthContext);
  useEffect(() => {
    setLoading(true);
    getCases();
  }, [getCases]);

  return (
    <Applayout>
      <div className="container-fluid">
        <div className="page-header">
          <div className="row">
            <div className="col">
              <div className="page-header-left">
                <h3>View Case</h3>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">
                      <i data-feather="home"></i>
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Case</li>
                  <li className="breadcrumb-item active">Default</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-header">
          <h4 className="card-title mb-0">
            {cases.title}
            <span
              className={`badge ml-3 ${
                cases.status === "approved"
                  ? "badge-success"
                  : cases.status === "pending"
                  ? "badge-info"
                  : cases.status === "declined"
                  ? "badge-danger"
                  : cases.status === "delivered"
                  ? "badge-delivered"
                  : cases.status === "in-review"
                  ? "badge-warning"
                  : "badge-secondary"
              }`}
              style={{ fontSize: "9px", marginLeft: "10px" }}
            >
              {cases.status}
            </span>

            {cases.proof && (
              <div className="pull-right">
                <button className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#viewProof"
                onClick={() => {
                  setModalTitle(
                    `View Proof`
                  );
                }}>
                  View Proof
                </button>
              </div>
            )}

            {(user.user_type === "project_officer" && cases.status === 'approved' && !cases.proof)  && (
              <div className="pull-right">
                <button className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#uploadProof"
                onClick={() => {
                  setModalTitle(
                    `Upload Proof`
                  );
                }}>
                  Upload Proof
                </button>
              </div>
            )}
            {!cases.case_manager_id && user.user_type === "case_manager" && (
              <div className="pull-right">
                <button className="btn btn-primary" onClick={showInterest}>
                  Show Interest
                </button>
              </div>
            )}

            {cases.status === 'in-review' && user.user_type === "project_manager" && (
              <div className="pull-right">
                <button className="btn btn-success btn-sm mx-2" onClick={() => approveCase()}>
                  Approve
                </button>
                <button className="btn btn-danger btn-sm mx-2" onClick={() => declineCase()}>
                  Decline
                </button>
              </div>
            )}

            {cases.case_manager_id &&  cases.case_manager_id === user.id && user.user_type === "case_manager" && cases.status === 'pending' && (
              <div className="pull-right">
                <button className="btn btn-success btn-sm mx-2" onClick={() => inReview()}>
                  Approve
                </button>
                <button className="btn btn-danger btn-sm mx-2" onClick={() => declineCase()}>
                  Decline
                </button>
              </div>
            )}
          </h4>
        </div>
        <div className="row">
          <div
            className="col-md-7"
            style={{ height: "400px", overflow: "auto" }}
          >
            <div className="card-body">
              <div className="summernote">
                <p
                  className="text-muted"
                  dangerouslySetInnerHTML={{ __html: cases.description }}
                ></p>
              </div>
            </div>
          </div>
          <div
            className="col-md-5"
            style={{ height: "400px", overflow: "auto" }}
          >
            <div className="card">
              <div className="card-header">
                <h5 className="card-title">
                  Case Documents
                  {cases.case_manager_id === user.id &&
                    user.user_type === "case_manager" && (
                      <div className="pull-right">
                        <button
                          className="badge badge-warning"
                          style={{ border: "none" }}
                          data-bs-toggle="modal"
                          data-bs-target="#requestDocument"
                          onClick={() => {
                            setModalTitle("View Document");
                          }}
                        >
                          Request
                        </button>
                      </div>
                    )}
                </h5>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <th>#</th>
                    <th>type</th>
                    <th>status</th>
                    <th>action</th>
                    <tbody>
                      {cases.case_documents &&
                      cases.case_documents.length > 0 ? (
                        cases.case_documents.map((caseDoc, index) => {
                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{caseDoc.requirement}</td>
                              <td>{caseDoc.status}</td>
                              <td>
                                {caseDoc.status === "submitted" ? (
                                  <button
                                    className="badge rounded-pill btn-primary"
                                    style={{ border: "none" }}
                                    data-bs-toggle="modal"
                                    data-bs-target="#viewDocuments"
                                    onClick={() => {
                                      setModalTitle(
                                        `View ${caseDoc.requirement}`
                                      );
                                      setDocumentId(caseDoc.id);
                                      setCurrentDoc(caseDoc);
                                    }}
                                  >
                                    View
                                  </button>
                                ) : (
                                  <span>
                                    {user.user_type === "project_officer" &&
                                      cases.project_officer_id === user.id && (
                                        <button
                                          className="badge rounded-pill btn-warning"
                                          style={{ border: "none" }}
                                          data-bs-toggle="modal"
                                          data-bs-target="#uploadDocument"
                                          onClick={() => {
                                            setModalTitle(
                                              `Upload ${caseDoc.requirement}`
                                            );
                                            setDocumentId(caseDoc.id);
                                          }}
                                        >
                                          Upload
                                        </button>
                                      )}
                                  </span>
                                )}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center bg-warning">
                            No documents available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-4">
          <div className="card card-body">
            <div className="table-responsive">
              <table className="table table-borderless">
                <tr>
                  <th rowSpan={3}>
                    <img
                      className="img-60 rounded-circle"
                      src={
                        cases.beneficiary?.photo ??
                        "../assets/images/avtar/user.jpeg"
                      }
                      alt="#"
                    />
                    <br />
                    Beneficiary
                  </th>

                  <td>
                    {cases.beneficiary &&
                      cases.beneficiary.first_name +
                        " " +
                        cases.beneficiary.last_name}
                  </td>
                </tr>
                <tr>
                  <td>{cases.beneficiary && cases.beneficiary.email}</td>
                </tr>
                <tr>
                  <td>{cases.beneficiary && cases.beneficiary.phone_number}</td>
                </tr>
                <tr></tr>
              </table>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className=" card card-body">
            <table className="table table-borderless">
              <tr>
                <th rowSpan={3}>
                  <img
                    className="img-60 rounded-circle"
                    src={
                      cases.project_officer?.photo ??
                      "../assets/images/avtar/user.jpeg"
                    }
                    alt="#"
                  />
                  <br />
                  Officer
                </th>
                <td>
                  {cases.project_officer &&
                    cases.project_officer.first_name +
                      " " +
                      cases.project_officer.last_name}
                </td>
              </tr>
              <tr>
                <td>{cases.project_officer && cases.project_officer.email}</td>
              </tr>
              <tr>
                <td>+234095985479</td>
              </tr>
            </table>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card card-body">
            {cases.case_manager ? (
              <table className="table table-borderless">
                <tr>
                  <th rowSpan={3}>
                    <img
                      className="img-60 rounded-circle"
                      src={
                        cases.case_manager?.photo ??
                        "../assets/images/avtar/user.jpeg"
                      }
                      alt="#"
                    />
                    <br />
                    Case Manager
                  </th>
                  <td>
                    {cases.case_manager &&
                      cases.case_manager.first_name +
                        " " +
                        cases.case_manager.last_name}
                  </td>
                </tr>
                <tr>
                  <td>{cases.case_manager && cases.case_manager.email}</td>
                </tr>
                <tr>
                  <td>+234095985479</td>
                </tr>
              </table>
            ) : (
              <div className="alert alert-warning">
                <h6 className="text-center">No Case Manager</h6>
              </div>
            )}
          </div>
        </div>
      </div>

      <Modal
        title={modalTitle}
        modalId="viewDocuments"
        modalSize="lg"
        modalPosition="centered"
      >
        <div className="row">
          {(cases.case_manager_id === user.id ||
            cases.project_officer_id === user.id) && (
            <div className="col-12">
              <p>
                You are not comfortable with the upload{" "}
                <span
                  className="badge badge-danger"
                  onClick={enableReupload}
                  style={{ cursor: "pointer" }}
                >
                  Reupload
                </span>
              </p>
            </div>
          )}
        </div>
        <iframe
          src={currentDoc.uploaded_file}
          width="100%"
          height="600px"
          title="Document Viewer"
        />
       
      </Modal>
      <Modal
        title={modalTitle}
        modalId="viewProof"
        modalSize="lg"
        modalPosition="centered"
      >
        <div>
          <iframe
            src={cases.proof}
            width="100%"
            height="600px"
            title="Proof Viewer"
          />
          <div className="mt-3 text-center">
            <button 
              type="button" 
              className="btn btn-danger"
              onClick={removeProof}
              disabled={loading}
            >
              {loading ? "Removing..." : "Remove Proof"}
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        title={modalTitle}
        onSave={uploadRequirement}
        modalId="uploadDocument"
        modalSize="md"
        modalPosition="centered"
      >
        <div className="file-uploader">
          <div
            className="upload-area"
            onClick={handleClick}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
          >
            {file ? (
              <p>{file.name}</p>
            ) : (
              <p>Drag & drop a file here or click to upload</p>
            )}
          </div>

          {/* Hidden input */}
          <input
            ref={fileInputRef}
            type="file"
            onChange={handleFileSelect}
            style={{ display: "none" }}
          />
        </div>
      </Modal>

      <Modal
        title={modalTitle}
        onSave={handleDocRequest}
        modalId="requestDocument"
        modalSize="md"
        modalPosition="centered"
      >
        <div className="row">
          <div className="col-md-12">
            <label className="form-label" htmlFor="requirement">
              Requirement
            </label>
            <input
              className="form-control"
              id="requirement"
              type="text"
              name="requirement"
              value={formData.requirement}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
      </Modal>

      <Modal
        title={modalTitle}
        onSave={uploadProof}
        modalId="uploadProof"
        modalSize="md"
        modalPosition="centered"
      >
        <div className="file-uploader">
          <div
            className="upload-area"
            onClick={handleClick}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
          >
            {file ? (
              <p>{file.name}</p>
            ) : (
              <p>Drag & drop a file here or click to upload</p>
            )}
          </div>

          {/* Hidden input */}
          <input
            ref={fileInputRef}
            type="file"
            onChange={handleFileSelect}
            style={{ display: "none" }}
          />
        </div>
      </Modal>

      <Modal title={modalTitle} modalId="viewDocument" modalSize="md" modalPosition="centered">
        <div className="row">
          <div className="col-md-12">
            {currentDoc.file_type === 'image' ? (
              <img src={currentDoc.file_path} alt="Document" className="img-fluid" />
            ) : (
              <embed src={currentDoc.file_path} width="100%" height="500px" />
            )}
          </div>
        </div>
      </Modal>
    </Applayout>
  );
}

export default Viewcase;
